/**
 * Organizatör panelindeki TÜM yol string'leri — TEK kaynak.
 *
 * `<AppLink to="/support">` yerine `<AppLink to={paths.support}>`; yeniden
 * adlandırma tek satır kalır. (bkz. admin'deki 2026-07 "Bildirimler → Kontrol
 * Merkezi" olayı: `/notifications` üç ayrı dosyada elle yazılmıştı.)
 *
 * Her girdi `toRoutePath()`'ten geçer → dönen değer `RoutePath` markasını taşır;
 * `lib/route-primitives.tsx` sarmalayıcıları yalnız bunu kabul eder.
 */
import { toRoutePath, type RoutePath } from "@wedding/shared";

export const paths = {
  root: toRoutePath("/"),
  /** Organizatör kaydı — yalnız oturumsuzken ve admin kaydı açtıysa anlamlı (`AuthGate`). */
  signup: toRoutePath("/signup"),
  /**
   * GÖRELİ hedef: "içinde bulunduğun rota eşleşmesinin index'i".
   * Düğün-içi `<Route path="*">` catch-all'ı bilinmeyen alt-yolu düğün
   * dashboard'una geri düşürmek için kullanır — slug'ı bilmeye gerek kalmadan.
   * Mutlak yol OLMADIĞI için `/` ile başlamaz; yine de bir navigasyon hedefi
   * olduğundan buradan, `toRoutePath()` üzerinden geçer.
   */
  self: toRoutePath("."),
  profile: toRoutePath("/profile"),
  /** Paketlerim — paketler + sipariş geçmişi (2026-10-16). Slug olarak rezerve (`RESERVED_SLUGS`). */
  packages: toRoutePath("/packages"),
  /** Düğünlerim, yeni düğün penceresi bu paket seçili açık (Paketlerim → "Bu paketle düğün aç"). */
  newWeddingWith: (packageId: string): RoutePath => toRoutePath(`/?${NEW_WEDDING_PACKAGE_PARAM}=${encodeURIComponent(packageId)}`),
  support: toRoutePath("/support"),
  supportDetail: (id: string): RoutePath => toRoutePath(`/support/${id}`),
  /** Destek listesi, tek ticket seçili (masaüstü iki-panel görünümü). */
  supportWithTicket: (id: string): RoutePath => toRoutePath(`/support?ticket=${id}`),
  wedding: {
    dashboard: (slug: string): RoutePath => toRoutePath(`/${slug}`),
    guests: (slug: string): RoutePath => toRoutePath(`/${slug}/guests`),
    moderation: (slug: string): RoutePath => toRoutePath(`/${slug}/moderation`),
    gallery: (slug: string): RoutePath => toRoutePath(`/${slug}/gallery`),
    sms: (slug: string): RoutePath => toRoutePath(`/${slug}/sms`),
    analytics: (slug: string): RoutePath => toRoutePath(`/${slug}/analytics`),
    print: (slug: string): RoutePath => toRoutePath(`/${slug}/print`),
    reji: (slug: string): RoutePath => toRoutePath(`/${slug}/control-room`),
    themes: (slug: string): RoutePath => toRoutePath(`/${slug}/themes`),
    settings: (slug: string): RoutePath => toRoutePath(`/${slug}/settings`),
  },
} as const;

/**
 * react-router DESEN'leri (örnek yol değil) — `<Route path=...>` için.
 * Reji tam-ekran olduğu için düğün chrome'unun DIŞINDA, üst seviyede mount edilir.
 *
 * ⚠️ BİLEREK markalanmaz: bunlar navigasyon HEDEFİ değil rota TANIMI. `RoutePath`
 * "gidilebilecek gerçek bir yol" demek; `"/:slug/control-room"` gidilebilir bir yol değil,
 * eşleşme deseni. `<Route path=>` zaten `string` bekler.
 */
export const routePatterns = {
  weddingReji: "/:slug/control-room",
  weddingCatchAll: "/:slug/*",
} as const;

/** Yeni düğün penceresinde ön seçili paket (`?package=<id>`). */
export const NEW_WEDDING_PACKAGE_PARAM = "package";
